import React from 'react';
import { Button } from '@/components/ui/button';
import { useOfferStore } from '@/lib/store';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export default function SimplePagination() {
  const positions = useOfferStore(s => s.positions);
  const searchTerm = useOfferStore(s => s.searchTerm);
  const currentPage = useOfferStore(s => s.currentPage);
  const pageSize = useOfferStore(s => s.pageSize);
  const setPage = useOfferStore((state) => state.setPage);
  const setPageSize = useOfferStore((state) => state.setPageSize);
  
  // Calculate total filtered positions
  const filteredPositions = React.useMemo(() => {
    if (!searchTerm) return positions;
    
    const lowerSearch = searchTerm.toLowerCase();
    return positions.filter(pos => 
      (pos.originalId && pos.originalId.toLowerCase().includes(lowerSearch)) ||
      (pos.gewerk && pos.gewerk.toLowerCase().includes(lowerSearch)) ||
      pos.beschreibung.toLowerCase().includes(lowerSearch) ||
      pos.einheit.toLowerCase().includes(lowerSearch) ||
      String(pos.preis).includes(searchTerm)
    );
  }, [positions, searchTerm]);
  
  // Calculate total pages
  const totalPages = Math.max(1, Math.ceil(filteredPositions.length / pageSize));
  
  // Go to previous page
  const goToPrevPage = () => {
    if (currentPage > 1) {
      setPage(currentPage - 1);
    }
  };
  
  // Go to next page
  const goToNextPage = () => {
    if (currentPage < totalPages) {
      setPage(currentPage + 1);
    }
  };
  
  return (
    <div className="flex items-center justify-end px-4 py-3 border-t border-gray-200 bg-white">
      <div className="flex items-center space-x-2">
        <Button
          variant="outline"
          size="sm"
          onClick={goToPrevPage}
          disabled={currentPage === 1}
          className="p-0 w-8 h-8"
        >
          <ChevronLeft className="h-4 w-4" />
        </Button>
        
        <Button
          variant="outline"
          size="sm"
          onClick={goToNextPage}
          disabled={currentPage >= totalPages}
          className="p-0 w-8 h-8"
        >
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}